import { baseQueryBuilder } from '@delmonicos/shared-sdk/libs/cpms/src/clients/utils/base-query.builder';

import { AUTH_REFRESH_TOKENS_ENDPOINT } from '@app/config/api-routes';
import {
  authenticate,
  getJwt,
} from '@app/core/authentication/authentication.slice';
import { ConfigurationService } from '@app/core/configuration/configuration.service';
import { InAppStorage } from '@app/core/storage/in-app-storage';

import type { RootState } from 'src/core/store';

export function buildBaseQuery(): ReturnType<typeof baseQueryBuilder> {
  return baseQueryBuilder({
    baseUrl: ConfigurationService.getApi(),
    refreshEndpoint: AUTH_REFRESH_TOKENS_ENDPOINT,
    getJwt: (state) => getJwt(state as RootState),
    getRefreshToken: () => InAppStorage.refreshToken,
    onTokensRefreshed: ({
      accessToken,
      newRefreshToken,
      wasRemembered,
      dispatch,
    }) => {
      InAppStorage.setJwt(accessToken, wasRemembered);
      InAppStorage.setRefreshToken(newRefreshToken, wasRemembered);
      dispatch(authenticate(accessToken));
    },
  });
}
